import type { PresenceEntry, Theme } from './types.js';

export const WS_FRAME_JSON = 0x00;
export const WS_FRAME_VIEWPORT = 0x01;
export const WS_FRAME_CURSOR = 0x02;
export const WS_FRAME_STROKE_BEGIN = 0x03;
export const WS_FRAME_STROKE_APPEND = 0x04;
export const WS_FRAME_STROKE_COMMIT = 0x05;
export const WS_FRAME_STROKE_ABORT = 0x06;
export const WS_FRAME_ERASE = 0x07;
/** v2 提交式协议：一笔的完整数据一次上行（本地实时渲染，落笔即整笔同步） */
export const WS_FRAME_STROKE_COMMIT_FULL = 0x08;
/** 撤销一次擦除：恢复该擦除事件对应的笔画（u32 event_id） */
export const WS_FRAME_UNERASE = 0x09;

export interface BoardInfo {
  id: number;
  slug: string;
  name: string;
  theme: Theme;
}

export type JsonMsg =
  | { t: 'hello'; server_time: string; board: BoardInfo; online: PresenceEntry[]; last_stroke_id: number }
  | { t: 'presence:join'; user: PresenceEntry }
  | { t: 'presence:leave'; user_id: string }
  | { t: 'cursor'; user_id: string; x: number; y: number }
  | { t: 'stroke:begin'; user_id: string; remote_id: string; tool: string; color: string; size: number; p0: [number, number, number] }
  | { t: 'stroke:append'; remote_id: string; points: [number, number, number][] }
  | { t: 'stroke:commit'; remote_id: string; stroke_id: number; bbox: [number, number, number, number] }
  | { t: 'stroke:abort'; remote_id: string }
  | { t: 'strokes:add'; strokes: Array<{ remote_id: string; stroke_id: number; user_id: string; tool: string; color: string; size: number; bbox: [number, number, number, number]; points: [number, number, number][] }> }
  | { t: 'stroke:erase'; stroke_ids: number[]; by_user_id: string; ev_id?: number }
  | { t: 'strokes:restore'; strokes: Array<{ stroke_id: number; user_id: string; tool: string; color: string; size: number; bbox: [number, number, number, number]; points: [number, number, number][] }> }
  | { t: 'board:cleared'; by_admin_id: string; scope: string }
  | { t: 'error'; code: string; reason: string };

export const RATE_LIMIT_MSG_PER_SEC = 100;
export const RATE_LIMIT_COMMIT_PER_SEC = 10;
export const CURSOR_THROTTLE_MS = 50;
export const VIEWPORT_THROTTLE_MS = 100;
export const APPEND_BATCH_MS = 33;
